import React from "react";
import "../../libraries/bootstrap-input-spinner";

class NumberSpinner extends React.Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
  }

  componentDidMount() {
    $(this.inputRef.current).inputSpinner();
    $(this.inputRef.current).on("change", (event) => {
      this.props.onChange(event);
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      $(this.inputRef.current).val(this.props.value);
    }
    if (this.props.hasError && this.props.hasError != "") {
      $('input[ref ="goob-gob"]').prop(
        "class",
        "form-control has-errors maximum_occupancy"
      );
    } else {
      $('input[ref ="goob-gob"]').prop("class", "form-control");
    }
  }

  render() {
    return (
      <div className="NumberSpinner">
        <input
          id={this.props.id}
          ref={this.inputRef}
          type="number"
          name={this.props.name}
          // onChange={this.props.onChange}
          defaultValue={
            typeof this.props.value !== "undefined" ? this.props.value : ""
          }
          min={this.props.min || 0}
          max={this.props.max != undefined ? this.props.max : 100}
          step={this.props.step || 1}
          data-decimals={this.props.data_decimals ? this.props.data_decimals : 0}
          className={
            (this.props.hasError
              ? this.props.hasError + " form-control"
              : "form-control") +
            " " +
            (this.props.className || " ")
          }
        />
      </div>
    );
  }
}

export default NumberSpinner;
